import * as React from "react";
const SvgMinusNew = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Icon" }, /* @__PURE__ */ React.createElement("path", { id: "icon", d: "M5 11V9H15V11H5Z" })));
export default SvgMinusNew;
